import classNames from "classnames/bind";
import style from "./SetupDefault.module.css";
import { Col, Loading, Row, SelectBox, SelectBoxItem, Toast } from "../../../components";
import { useState } from "react";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { useEffect } from "react";
import ConfigStream from "./ConfigStream";
import ConfigAi from "./ConfigAI";
import { configDefault } from "../../../services/api/configDefault";
import InProcessBuild from "../../../components/InProcessBuild";

const cx = classNames.bind(style);

function SetupDefault() {
    const [listService, setListService] = useState([
        {
            label: 'Xem trực tiếp',
            code: 'xtt',
        },
        {
            label: 'Xem lại',
            code: 'xl',
        }
    ]);
    const [serviceCode, setServiceCode] = useState('xtt');
    const [dataStore, dispatch] = useStoreContext();
    const [dataConfig, setDataConfig] = useState();
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const handleRefresh = () => {
        setRefresh(!refresh)
    }
    const handleChangeService = (data) => {
        setServiceCode(data)
        handleRefresh()
    }

    useEffect(() => {
        const aiService = dataStore.listService.map((item) => {
            return {
                label: item.SUBJECT_NAME,
                code: item.CODE
            }
        })
        setListService(prev => [...prev, ...aiService]);
    }, [dataStore.listService])

    useEffect(() => {
        const getDefaultConfig = async () => {
            try {
                const res = await configDefault.getAllConfig()
                setDataConfig(res.data)
                setLoading(false)
            } catch (error) {
                Toast.open('Lấy cấu hình không thành công', 'danger')
                setLoading(false)
            }
        }
        getDefaultConfig()
    }, [refresh])
    return (
        <>
            {loading ? <div className={cx('modal-load')}><Loading /> </div> : (
                <div className={cx('manager-wrapper')}>
                    <div className={cx("header")}>
                        <h1 className={cx("title")}>Thiết lập mặc định</h1>
                    </div>
                    <Row gap={[0, 16]} style={{ marginLeft: '8px', minHeight: 42 }} >
                        <Col span={6}>
                            <div className={cx("name")}>
                                Dịch vụ
                            </div>
                        </Col>
                        <Col span={6}>
                            <div className={cx("control")}>
                                <SelectBox
                                    type="small"
                                    values={listService.find(item => item.code === serviceCode)?.label ?
                                        listService.find(item => item.code === serviceCode)?.label :
                                        null
                                    }
                                    onChange={handleChangeService}
                                    style={{ flex: 0.4 }}
                                >
                                    {listService.length > 0 ?
                                        (listService.map((item) => {
                                            return (
                                                <SelectBoxItem key={item.code} value={item.code} label={item.label} />
                                            )
                                        })) : (
                                            <></>
                                        )}
                                </SelectBox>
                            </div>
                        </Col>
                    </Row>
                    <div className={cx('border')}></div>
                    {serviceCode === 'xtt' || serviceCode === 'xl' ?
                        <ConfigStream
                            label={
                                listService.find(item => item.code === serviceCode)?.label ?
                                    listService.find(item => item.code === serviceCode)?.label.toLocaleLowerCase() :
                                    ''
                            }
                            codeService={serviceCode}
                            config={dataConfig}
                            handleRefresh={handleRefresh}
                        /> :
                        (true ? <ConfigAi
                            label={
                                listService.find(item => item.code === serviceCode)?.label ?
                                    listService.find(item => item.code === serviceCode)?.label.toLocaleLowerCase() :
                                    ''
                            }
                            codeService={
                                listService.find(item => item.code === serviceCode)?.code ?
                                    listService.find(item => item.code === serviceCode)?.code :
                                    ''
                            }
                            config={dataConfig}
                            handleRefresh={handleRefresh}
                        /> : <InProcessBuild />)
                    }
                </div>
            )}
        </>
    )
}


export default SetupDefault;